$(document).ready(function() {
  //Slide banner
//     $(".eco-slide-show").owlCarousel({
//         items: 1,
//         pagination: true,
//         autoHeight: false,
//         loop: true,
//         navigation: true,
//         navigationText : ["<i class='fa fa-chevron-left'></i>","<i class='fa fa-chevron-right'></i>"]
//     });

  //Slide thumbnails
    $(".nv-slide-thumbnails").owlCarousel({
        items: 4,
        pagination: false,
        dots: false,
        autoHeight: false,
      	autoWidth:false,
        scrollPerPage: true,
        loop: false,
        nav: true,
        navText : ["<i class='fa fa-angle-left'></i>","<i class='fa fa-angle-right'></i>"]
    });
  //You may also like cart
//     $(".eco-related-products-cart-wrap").owlCarousel({
//         items: 4,
//         pagination: false,
//         nav: true,
//         loop: true,
//         responsive:{
//             0:{
//                 items:1
//             },
//             600:{
//                 items:4
//             }
//         },
//         margin: 30,
//         navText : ["<i class='fa fa-angle-left'></i>","<i class='fa fa-angle-right'></i>"],
//         dots: false
//     });
  
});
